import { render, staticRenderFns } from "./ActionCenter.vue?vue&type=template&id=6f7c9f96&scoped=true"
import script from "./ActionCenter.vue?vue&type=script&lang=js"
export * from "./ActionCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c9f96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7c9f96')) {
      api.createRecord('6f7c9f96', component.options)
    } else {
      api.reload('6f7c9f96', component.options)
    }
    module.hot.accept("./ActionCenter.vue?vue&type=template&id=6f7c9f96&scoped=true", function () {
      api.rerender('6f7c9f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/ActionCenter.vue"
export default component.exports